import React from 'react';
import Table from '@awp/components/table';
import { sortByNumericThenAlpha } from '@awp/helpers/sorter';
import { Button } from 'react-bootstrap';
import { SystemAdminRole } from '@awp/constants';
import { Crud } from '@awp/shared/Crud';

const RolesTable = ({
  isMedium,
  isLarge,
  data,
  loading,
  setMode,
  mode,
  setRole,
  defaultPageSize,
  setDefaultPageSize,
}) => {
  const crud = new Crud('User Roles', mode);

  const actionMenu = (row) => {
    return (
      <>
        <div>
          {row.row.original.Name !== SystemAdminRole && (
            <i
              className="fas fa-edit mx-1 my-1 awp-img-btn"
              title="Edit"
              onClick={() => {
                setMode('edit');
                setRole(row.row.original);
              }}
            ></i>
          )}
          <i
            className="fas fa-eye mx-1 my-1 awp-img-btn"
            title="View"
            onClick={() => {
              setMode('view');
              setRole(row.row.original);
            }}
          ></i>
        </div>
      </>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'Name',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Description',
        accessor: 'Description',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Users',
        accessor: 'NumUsers',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Last Updated',
        accessor: 'BusinessLastUpdateTimestampPst',
        sortType: sortByNumericThenAlpha,
      },
      {
        Header: 'Actions',
        accessor: 'Id',
        disableSortBy: true,
        Cell: actionMenu,
      },
    ],
    [isLarge, isMedium],
  );

  return (
    <>
      <div className="d-flex">{crud.getHeader()}</div>
      <Table
        columns={columns}
        data={data}
        fetchData={() => {}}
        loading={loading}
        search=""
        defaultSortBy="Name"
        defaultPageSize={defaultPageSize}
        setDefaultPageSize={setDefaultPageSize}
      />
      <div style={{ paddingTop: '1.25rem' }}>
        <Button
          className="mr-2"
          variant="primary"
          onClick={() => {
            setMode('create');
          }}
          disabled={loading}
        >
          Create New Role
        </Button>
      </div>
    </>
  );
};

export default RolesTable;
